import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-savings-chart-tooltip',
  styleUrls: ['./savings-chart-tooltip.component.scss'],
  templateUrl: './savings-chart-tooltip.component.html',
  standalone: false
})
export class SavingsChartTooltipComponent {
  @Input() currency: string;
  @Input() kind: string;
  @Input() language: string;
  @Input() tooltipData: { expected: number; potential: number; loss: number };
  @Output() toggleDetails = new EventEmitter<string>();

  onToggleDetails() {
    this.toggleDetails.emit('[Button] SP chart tooltip: Toggle details');
  }
}
